// extracted by mini-css-extract-plugin
module.exports = {"synonyms":"Synonyms_synonyms__DCyUW"};